import { Tooltip } from "@fragments";

/**
 * ControlButton — a single translucent chip button of the player chrome.
 * Fragment Buttons carry ripples/loading machinery the 60fps chrome doesn't
 * want; this is the minimal accessible button the control bar is built from.
 */
export default function ControlButton({ label, onClick, disabled = false, active = false, className = "", children }) {
    return (
        <Tooltip content={label} placement="top">
            <button
                type="button"
                aria-label={label}
                aria-pressed={active || undefined}
                disabled={disabled}
                className={`player-control-button ${active ? "active" : ""} ${className}`.trim()}
                onClick={(event) => {
                    event.stopPropagation();
                    onClick?.(event);
                }}
            >
                {children}
            </button>
        </Tooltip>
    );
}
